// import MomentUtils from '@date-io/moment';
import { FormControl, FormControlLabel, FormLabel, MenuItem, Radio, RadioGroup, Select } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';
// import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import decodeJwt from 'jwt-decode';
import { Button } from 'ra-ui-materialui';
import React, { useEffect } from 'react';
import { Error, Loading } from 'react-admin';
import DateTimePicker from 'react-datetime-picker';
import XLSX from 'xlsx';
import ReportTable from '../../components/reports/ReportTable';
const config = require('./../../config.json');


const ReportMachinesByTime = () => {
    const [search, setSearch] = React.useState(false);
    const [_data, setData] = React.useState(null);
    const [_error, setError] = React.useState(null);
    const [_loading, setLoading] = React.useState(null);
    const [buildings, setBuildings] = React.useState([]);
    const [buildingId, setBuildingId] = React.useState(null);
    const [selectedDateInit, setSelectedDateInit] = React.useState(new Date())
    const [selectedDateEnd, setSelectedDateEnd] = React.useState(new Date())

    const searchFunction = () => {
        setSearch(true);
    }

    useEffect(() => {
        if (buildings.length === 0) {
            let a = '';
            if (localStorage.getItem('token')) {
                a = decodeJwt(localStorage.getItem("token")).access_token
            }
            fetch(config.API_URL + `/buildings?_end=500&_order=ASC&_sort=address&_start=0`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': a
                }
            })
                .then(res => {
                    return res.json();
                })
                .then(data => {
                    setBuildings(data);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }, [buildings])

    useEffect(() => {
        if (search) {
            let a = '';
            if (localStorage.getItem('token')) {
                a = decodeJwt(localStorage.getItem("token")).access_token
            }
            setLoading(true);
            let init_date = selectedDateInit.toISOString().slice(0, 16).replace('T', ' ');
            let end_date = selectedDateEnd.toISOString().slice(0, 16).replace('T', ' ');
            let url = config.API_URL + `/stats/monthly-machine?init_date=${init_date}&end_date=${end_date}`;
            if (buildingId !== null) {
                url += `&buildingId=${buildingId}`;
            }
            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': a
                }
            })
                .then(res => {
                    return res.json();
                })
                .then(data => {
                    setData(data);
                    setLoading(false);
                })
                .catch(error => {
                    setError(error);
                    setLoading(false);
                });
            setSearch(false);
        }
    }, [search, selectedDateEnd, selectedDateInit, buildingId]);

    if (_loading) return <Loading />;
    if (_error) return <Error />;
    if (search && !_data) return null;

    // Remove " and \ from content
    // data.event_information.data.forEach((obj: any) => {
    // obj.content = JSON.stringify(obj.content).replace(/(")|(\\)/g, '');
    // })

    // const meses = {
    //     1: 'Enero',
    //     2: 'Febrero',
    //     3: 'Marzo',
    //     4: 'Abril',
    //     5: 'Mayo',
    //     6: 'Junio',
    //     7: 'Julio',
    //     8: 'Agosto',
    //     9: 'Septiembre',
    //     10: 'Octubre',
    //     11: 'Noviembre',
    //     12: 'Diciembre'
    // }

    const handleChangeBuilding = (event) => {
        setBuildingId(event.target.value);
    }

    const handleDownload = () => {
        let workBook = XLSX.utils.book_new();

        workBook.Props = {
            Title: "Reporte uso máquinas y edificos al por fechas",
            Subject: "Reportes Speedclean",
            Author: "desarrollo@speedclean.cl",
            CreatedDate: new Date(Date.now()),
        };

        Object.keys(_data).forEach((reportKey) => {
            workBook.SheetNames.push(reportKey);
            workBook.Sheets[reportKey] = XLSX.utils.json_to_sheet(_data[reportKey]);
        })
        XLSX.writeFile(workBook, 'resumenFechasMaquinaEdificio.xlsx');
    }

    const handleDateChangeInit = (date) => {
        setSelectedDateInit(date);
    };

    const handleDateChangeEnd = (date) => {
        setSelectedDateEnd(date);
    };

    return (
        <div>
            <FormControl component="fieldset">
                <FormLabel component="legend">Fecha inicio:</FormLabel>
                <RadioGroup aria-label="date" name="date">
                    <FormControlLabel
                        value="custom"
                        control={<Radio />}
                        label={
                            <DateTimePicker
                                value={selectedDateInit}
                                onChange={handleDateChangeInit}
                                format="yyyy-MM-dd HH:mm"
                            />
                        }
                    />
                </RadioGroup>
            </FormControl>
            <br />
            <FormControl component="fieldset">
                <FormLabel component="legend">Fecha término:</FormLabel>
                <RadioGroup aria-label="date" name="date">
                    <FormControlLabel
                        value="custom"
                        control={<Radio />}
                        label={
                            <DateTimePicker
                                value={selectedDateEnd}
                                onChange={handleDateChangeEnd}
                                format="yyyy-MM-dd HH:mm"
                            />
                        }
                    />
                </RadioGroup>
            </FormControl>
            <br />
            {buildings.length !== 0 &&
                <FormControlLabel
                    control={<Select
                        style={{ width: '30%' }}
                        onChange={handleChangeBuilding}
                    >
                        {[null, ...buildings].map((building) => {
                            if (building === null) {
                                return <MenuItem key={"sin-id"} value={null}>-</MenuItem>
                            }
                            return (
                                <MenuItem key={building.id} value={building.id}>{building.address}</MenuItem>
                            )
                        })}
                    </Select>
                    }
                    label="Seleccionar edificio (opcional)"
                    labelPlacement="top"
                    style={{ margin: 'auto', width: '100%' }}
                />}
            <br />
            <br />
            <Button
                variant="contained"
                color="primary"
                onClick={searchFunction}
                style={{ margin: 'auto', width: '30%', display: "flex", justifyContent: "center", alignItems: "center" }}
                label="Buscar"
            />
            {_data ?
                <div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h1>Resumen por máquina y edificio</h1>
                        <Button
                            onClick={handleDownload}
                            label="Descargar Reporte de máquinas"
                            style={{ height: '2.5rem' }}
                        >
                            <GetApp />
                        </Button>
                    </div>
                    <h2>Resumen de máquinas</h2>
                    <ReportTable headers={[
                        'Código',
                        'Ciclos pago',
                        'Monto asociado pago',
                        'Edificio',
                        'Ciclos personal',
                        'Monto asociado personal',
                    ]}
                        keyNames={[
                            'code',
                            'use',
                            'amount',
                            'address',
                            'use_personal',
                            'amount_personal',
                        ]}
                        data={_data.machines} />
                    <h2>Resumen de edificios</h2>
                    <ReportTable headers={[
                        'Edificio',
                        'Ciclos pago',
                        'Monto asociado pago',
                        'Ciclos personal',
                        'Monto asociado personal',
                    ]}
                        keyNames={[
                            'address',
                            'use',
                            'amount',
                            'use_personal',
                            'amount_personal',
                        ]}
                        data={_data.buildings} />
                </div>
                : <></>
            }
        </div>

    )
}

export default ReportMachinesByTime;